import React, { useEffect } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  useTheme,
  TextareaAutosize,
} from "@mui/material";
import { useFormik } from "formik";

const EditCatatanModal = ({ open, dataEdit, onClose, onSubmit }) => {
  const theme = useTheme();

  const formik = useFormik({
    initialValues: {
      catatan: "",
    },
    onSubmit: (values) => {
      onSubmit(values.catatan);
      formik.resetForm();
      onClose();
    },
  });

  useEffect(() => {
    if (open) {
      formik.setValues({
        catatan: dataEdit.catatan || "",
      });
    } else if (!dataEdit) {
      formik.resetForm();
    }
  }, [open, dataEdit]);

  if (!open) {
    return null;
  }

  return (
    <Dialog open={open} onClose={onClose} maxWidth="sm" fullWidth>
      <DialogTitle>Edit Catatan</DialogTitle>
      <form onSubmit={formik.handleSubmit}>
        <DialogContent>
          <Grid container spacing={2}>
            <Grid item xs={12}>
              <TextareaAutosize
                minRows={4}
                style={{
                  width: "100%",
                  padding: 8,
                  borderColor:
                    formik.touched.catatan && formik.errors.catatan
                      ? "red"
                      : "lightgray",
                  borderWidth: 1,
                  borderRadius: 4,
                }}
                name="catatan"
                value={formik.values.catatan}
                onChange={formik.handleChange}
                placeholder="Catatan"
              />
              {formik.touched.catatan && formik.errors.catatan && (
                <div
                  style={{
                    color: "red",
                    fontSize: "0.75rem",
                    marginTop: 4,
                  }}
                >
                  {formik.errors.alamat}
                </div>
              )}
            </Grid>
          </Grid>
        </DialogContent>

        <DialogActions>
          <Button
            variant="contained"
            color="inherit"
            onClick={onClose}
            sx={{ fontSize: "14px", fontWeight: "bold", padding: "10px 20px" }}
          >
            Batal
          </Button>
          <Button
            type="submit"
            variant="contained"
            sx={{
              backgroundColor: theme.palette.secondary.light,
              color: theme.palette.background.alt,
              fontSize: "14px",
              fontWeight: "bold",
              padding: "10px 20px",
              "&:hover": {
                backgroundColor: theme.palette.secondary[500],
              },
            }}
          >
            Simpan
          </Button>
        </DialogActions>
      </form>
    </Dialog>
  );
};

export default EditCatatanModal;
